import { Flex } from "@p0security/ui";
import { GraphTooltip } from "components/GraphTooltip";

export const CredentialTitle: React.FC<object> = () => (
  <div className="flex flex-col">
    <div>Authentication Methods</div>
    <Flex align="flex-start" gap="1em">
      <Flex className="text-[small] font-normal whitespace-nowrap">
        <GraphTooltip title="An unused credential has not been used for 40 days">
          used / unused
        </GraphTooltip>{" "}
      </Flex>
      <Flex className="text-[small] font-normal whitespace-nowrap">
        <GraphTooltip title="A stale credential has not been rotated for 90 days">
          stale / fresh
        </GraphTooltip>
      </Flex>
    </Flex>
  </div>
);
